module.exports = __webpack_public_path__ + "img/server-phone-icon.fee32e5c.svg";